import { createSlice } from "@reduxjs/toolkit";

const userDataSlice = createSlice({
  name: "userDataSlice",
  initialState: {
    userData: null,
  },
  reducers: {
    setUserData(state, { payload }) {
      state.userData = payload;
    },
  },
});

export default userDataSlice.reducer;

export const { setUserData } = userDataSlice.actions;
